// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__tOIPP","pageHeaderContainer":"Header_pageHeaderContainer__3oVcN","headerTitle":"Header_headerTitle__1f19X"};